import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import searchIcon from "../images/search_icon.svg";
import { handleSearchData, receivedSearch, receivedSearchArt } from "../actions/list";
import PropTypes from "prop-types";
import UIkit from "uikit";
class SearchWidget extends Component {

    static propTypes = {
        search: PropTypes.string,
        searchArt: PropTypes.string
    }

    constructor(props) {
        super(props);
        this.timeout = null;

        const searchParams = new URLSearchParams(this.props.location.search.replace('?'));
        const searchArt = searchParams.get('searchArt');
        const search = searchParams.get('search');
        console.log( "SEARCH ", searchArt, search );
        const searchType = (searchArt || search)?(searchArt?'searchArt':'search'):'search';
        console.log("SEARCH", searchType);
        this.state = {
            searchType: searchType,
        }
    }



    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if ( !this.isOnPageWithSearch() ){
    //         this.props.setSearchData(null);
    //     }
    // }


    isOnPageWithSearch = () => {
        return this.props.location.pathname.match(/products\/ua\?page=*.*&limit=*.*&search=*.*/) ? true : false
    }

    doSearch(evt, searchField) {
        var searchText = evt.target.value; // this is the search text
        //this.setState({ searchValue: decodeURI(searchText) })
        if (searchField === 'search') {
            this.props.setSearchData(decodeURI(searchText));
            this.props.setSearchArtData("");
        } else {
            this.props.setSearchArtData(decodeURI(searchText));
            this.props.setSearchData("");
        }
        // if (this.props.isMobile) {
        //     UIkit.modal("#modal-search").hide();
        // }

    }

    submitSearch(evt, field) {
        const searchText = field === 'search' ? this.props.search : this.props.searchArt;
        this.props.history.push(`/products/ua?page=1&limit=12&${field}=${searchText}`);
    }
    handleChangeSearchType(e) {
        this.setState({ searchType: e.target.value });

    }

    render() {
        const { t } = this.props;
        const searchValue = this.props[this.state.searchType]!=='null'?this.props[this.state.searchType]:'';
        console.log("debug 71", searchValue, this.props, this.state.searchType);
        return (
            <div className="uk-position-relative ">
                <div>
                    <input className="uk-input header__search-input"
                        type={"text"}
                        value={searchValue}
                        placeholder={t("shop.search")}
                        onKeyDown = {e => {
                            if (e.key === 'Enter') {
                                this.submitSearch(e, this.state.searchType)
                            }
                            }} 
                        onChange={e => this.doSearch(e, this.state.searchType)} />
                    <select value={this.state.searchType} className="uk-select header__search-form" onChange={e => this.handleChangeSearchType(e)}>
                        <option value="search">{t("shop.search_by_name")}</option>
                        <option value="searchArt">{t("shop.search_by_art")}</option>
                    </select>

                    <button className="header__search-btn" onClick={e => this.submitSearch(e, this.state.searchType)}> <img src={searchIcon} uk-svg="" /></button>
                </div>
                {/* <div className={""}>
                    <input className="uk-input"
                           type={"text"}
                           value={this.props.search !== 'null' ? this.props.search : ""}
                           placeholder={t("shop.search")}
                           onChange={e=>this.doSearch(e, 'search')}
                    />
                    <img className="header__search-btn" src={searchIcon} uk-svg=""/>
                    <button className={"uk-button"} onClick={e=>this.submitSearch(e,'search')}>Go</button>
                </div>

                <div className={""}>
                    <input className="uk-input"
                           type={"text"}
                           value={this.props.searchArt !== 'null' ? this.props.searchArt : ""}
                           placeholder={t("shop.search")}
                           onChange={e=>this.doSearch(e, 'searchArt')}
                    />
                    <img className="header__search-btn" src={searchIcon} uk-svg=""/>
                    <button className={"uk-button"} onClick={e=>this.submitSearch(e,'searchArt')}>Go</button>
                </div> */}


            </div>
        )
    }
}

/**
 *
 * @param dispatch
 * @returns {{getProductsList: getProductsList}}
 */
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setSearchData: (value) => {
            dispatch(receivedSearch(value));
        },
        setSearchArtData: (value) => {
            dispatch(receivedSearchArt(value));
        },
    }
}

const mapStateToProps = (store) => {
    const {
        search,
        searchArt
    } = store.goods;
    return {
        search: decodeURI(search),
        searchArt: decodeURI(searchArt)
    };
};

const Search = withTranslation("translations")(SearchWidget);
export default connect(mapStateToProps, mapDispatchToProps)(Search);
